module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 alert-container-padding-zero"
  }, [_c('alertbar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [(_vm.$route.query.action === 'edit') ? _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_edit')))]) : _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_new')))]), _vm._v(" "), _c('step', {
    attrs: {
      "currentStep": 1,
      "maxStep": 5
    },
    on: {
      "step_clicked": _vm.gotoPage
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.personal_info')))]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.experience')))]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.schedules')))]), _vm._v(" "), _c('div', {
    slot: "4"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.education')))]), _vm._v(" "), _c('div', {
    slot: "5"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.other_info')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.personal_info')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_general.name_th')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "prefix-th"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_general.prefix')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor_profile_th.prefix),
      expression: "doctor_profile_th.prefix"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "prfix-th",
      "placeholder": _vm.$t('message.doctor_general.prefix_placeholder_th')
    },
    domProps: {
      "value": (_vm.doctor_profile_th.prefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doctor_profile_th.prefix = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "firstname-th"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_general.firstname')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor_profile_th.firstname),
      expression: "doctor_profile_th.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "firstname-th",
      "placeholder": _vm.$t('message.doctor_general.firstname')
    },
    domProps: {
      "value": (_vm.doctor_profile_th.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doctor_profile_th.firstname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "lastname-th"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_general.lastname')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor_profile_th.lastname),
      expression: "doctor_profile_th.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "lastname-th",
      "placeholder": _vm.$t('message.doctor_general.lastname')
    },
    domProps: {
      "value": (_vm.doctor_profile_th.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doctor_profile_th.lastname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_general.name_en')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "prefix-en"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_general.prefix')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor_profile_en.prefix),
      expression: "doctor_profile_en.prefix"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "prefix-en",
      "placeholder": _vm.$t('message.doctor_general.prefix_placeholder_en')
    },
    domProps: {
      "value": (_vm.doctor_profile_en.prefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doctor_profile_en.prefix = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "firstname-en"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_general.firstname')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor_profile_en.firstname),
      expression: "doctor_profile_en.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "firstname-en",
      "placeholder": _vm.$t('message.doctor_general.firstname')
    },
    domProps: {
      "value": (_vm.doctor_profile_en.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doctor_profile_en.firstname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "lastname-en"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_general.lastname')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor_profile_en.lastname),
      expression: "doctor_profile_en.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "lastname-en",
      "placeholder": _vm.$t('message.doctor_general.lastname')
    },
    domProps: {
      "value": (_vm.doctor_profile_en.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doctor_profile_en.lastname = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_general.gender')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "gender-select"
  }, [_c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.gender),
      expression: "doctor.gender"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio1",
      "value": "m"
    },
    domProps: {
      "checked": _vm._q(_vm.doctor.gender, "m")
    },
    on: {
      "__c": function($event) {
        _vm.doctor.gender = "m"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-male fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.doctor_general.male')) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.gender),
      expression: "doctor.gender"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "inlineRadioOptions",
      "id": "inlineRadio2",
      "value": "f"
    },
    domProps: {
      "checked": _vm._q(_vm.doctor.gender, "f")
    },
    on: {
      "__c": function($event) {
        _vm.doctor.gender = "f"
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-female fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.doctor_general.female')) + "\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_general.image')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('drop-zone', {
    staticClass: "crop-profile-image-dropzone",
    class: {
      'profile-image-active': _vm.isProfileImage
    },
    attrs: {
      "placeholder": _vm.profileImagePlaceholder
    },
    on: {
      "fileChange": _vm.profileImageFileChange
    }
  }), _vm._v(" "), _c('img', {
    ref: "crop-profile-image",
    staticClass: "crop-profile-image",
    attrs: {
      "src": _vm.profile_image_src
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('message.doctor_general.albums')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    attrs: {
      "id": "alblum-wrapper"
    }
  }, [_vm._l((_vm.doctor.images), function(img) {
    return (!img.is_active) ? _c('div', {
      key: img.id,
      staticClass: "image-in-alblum-wrapper"
    }, [_c('i', {
      staticClass: "fa fa-2x fa-times remove-image-from-alblum",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.removeImageFromAlblum(img.id)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "image-in-alblum",
      attrs: {
        "src": img.file_thumb
      }
    })]) : _vm._e()
  }), _vm._v(" "), _c('vue-core-image-upload', {
    class: ['btn', 'btn-primary', 'btn-upload-image'],
    attrs: {
      "crop": false,
      "max-file-size": 5242880,
      "input-of-file": "image",
      "url": _vm.profile_upload_album
    },
    on: {
      "imageuploaded": _vm.imageAlblumUploaded
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-plus plus-image",
    attrs: {
      "title": "remove image",
      "aria-hidden": "true"
    }
  })])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg"
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), (_vm.$route.query.action === 'edit') ? _c('button', {
    staticClass: "btn btn-delete btn-right btn-lg",
    on: {
      "click": _vm.deleteDoctor
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])])]), _vm._v(" "), _c('sweet-modal', {
    ref: "crop-modal",
    attrs: {
      "overlay-theme": "dark"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-croppie', {
    ref: "croppieRef",
    attrs: {
      "enableOrientation": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelCrop($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.confirmCrop($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.ok')))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68f769f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/doctor/steps/General.vue
// module id = 1026
// module chunks = 1